<script lang="ts" setup>
const { t } = useTranslation()
const userStore = useUserStore()
const myAccountRoute = computed(() => ({ name: 'kundenkonto-userId', params: { userId: userStore.userId } }))
</script>

<template>
  <div
    v-if="userStore.userId"
    m-auto
    flex="~ col"
    class="items-center justify-center lt-sm:w-full"
    w="540px"
  >
    <IaThemeIcon
      icon="i-fad:check"
      size="2xl"
      variant="filled"
      class="text-success-500 bg-success-50"
    />
    <IaHeading
      class="mt-8 text-center"
      :level="2"
      color="gray-800"
      font-700
    >
      {{ t('epaper.successPage.unsubscribe.heading') }}
    </IaHeading>
    <IaParagraph
      class="mt-4 !text-grey-600"
    >
      Sie können das E-Paper jederzeit wieder abonnieren.
    </IaParagraph>
    <div
      flex="~ col gap-6 lg:row"
      class="items-center m-auto justify-center lt-sm:gap-4"
      mt-6
      w-full
    >
      <IaNuxtLink
        to="/"
      >
        <IaButton
          variant="primary"
          normal-case
          class="lt-sm:w-full"
        >
          {{ t('epaper.successPage.unsubscribe.toHomepage') }}
        </IaButton>
      </IaNuxtLink>
      <IaNuxtLink
        :to="myAccountRoute"
      >
        <IaButton
          variant="outline"
          normal-case
          class="lt-sm:w-full"
        >
          {{ t('epaper.successPage.unsubscribe.manageSubscription') }}
        </IaButton>
      </IaNuxtLink>
    </div>
  </div>
</template>
